// @ts-nocheck — see ./constants for taxonomy duplicate-key context; this file
// additionally performs dynamic string indexing into typed enums in betTracking.
import {
  type ITrackingActions,
  type ITrackingProps,
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS,
} from './constants';

interface IBetTracking {
  bookieCode: string;
  category?: string;
  label: string;
}

class TrackingActions implements ITrackingActions {
  public eventTracking(obj: ITrackingProps): void {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        eventLabel: obj.eventLabel || undefined,
        ...obj,
      });
    }
  }

  public betTracking = ({ bookieCode, category, label }: IBetTracking): void => {
    this.eventTracking({
      event: TRACKING_EVENTS[label],
      eventCategory: category || TRACKING_CATEGORIES.HOMEPAGE,
      eventAction: TRACKING_ACTIONS[TRACKING_EVENTS[label]],
      eventLabel: bookieCode,
    });
  };

  public addObjectToDataLayer(obj: any): void {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(obj);
    }
  }
}

export default TrackingActions;

// Stateless, no-arg singleton: every former ServicesProvider consumer constructed
// `new TrackingActions()` with an empty memo dep array, so a shared module instance
// is equivalent and removes the need to thread tracking through React context.
export const trackingActions = new TrackingActions();
